/**
 * FJ Collection chips filter for .fj-card items.
 * Kategori-chips bytter produktgrid PAA STEDET (AJAX) - ingen sidehopp.
 */
(function () {
  const chipSelector = '.fj-chip, [data-fj-chip]';

  function getScope(bar) {
    const section = bar.closest('.shopify-section') || bar.closest('section');
    if (section) {
      const grid = section.querySelector('#product-grid');
      if (grid) return grid;
    }
    return document.querySelector('#product-grid') || document;
  }

  function setActive(bar, activeChip) {
    const chips = Array.from(bar.querySelectorAll(chipSelector));
    chips.forEach((chip) => {
      const isActive = chip === activeChip;
      chip.classList.toggle('is-active', isActive);
      chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function applyFilter(bar, filter) {
    const scope = getScope(bar);
    const cards = Array.from(scope.querySelectorAll('.fj-card'));
    if (!cards.length) return;

    let visibleCount = 0;
    cards.forEach((card) => {
      let show = true;
      if (filter && filter !== 'all') {
        const attr = 'data-fj-' + filter;
        show = card.getAttribute(attr) === '1';
      }
      card.style.display = show ? '' : 'none';
      if (show) visibleCount++;
    });

    if (visibleCount === 0) {
      cards.forEach((card) => {
        card.style.display = '';
      });
      const allChip = bar.querySelector('[data-filter="all"]');
      if (allChip) setActive(bar, allChip);
    }
  }

  // AJAX-bytt produktgrid uten aa flytte brukeren (skittfiske-stil)
  function swapCollection(bar, chip, collection) {
    const url = '/collections/' + collection;
    if (bar && chip) setActive(bar, chip);
    swapByUrl(url);
  }

  function swapByUrl(url) {
    const grid = document.querySelector('#product-grid');
    if (!grid) {
      window.location.href = url;
      return;
    }
    grid.style.transition = 'opacity .15s';
    grid.style.opacity = '0.35';

    fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('#product-grid');
        if (!newGrid) throw new Error('no grid');
        grid.innerHTML = newGrid.innerHTML;
        grid.style.opacity = '';

        // produkt-teller
        const oldCount = document.querySelector('#ProductCountDesktop, #ProductCount, .product-count__text');
        const newCount = doc.querySelector('#ProductCountDesktop, #ProductCount, .product-count__text');
        if (oldCount && newCount) oldCount.innerHTML = newCount.innerHTML;

        // Rettet 17.08.2026 (temarevisjonen): pagineringen maa OGSAA byttes.
        // Uendelig rulling (tb27 i fj-tb15.liquid) leser neste-side-lenken fra
        // dokumentets paginering. Uten dette byttet fortsatte den aa hente
        // side 2 av FORRIGE kolleksjon og la fiskeprodukter under jaktgriden.
        const oldPag = document.querySelector('.pagination-wrapper, nav.pagination, .pagination');
        const newPag = doc.querySelector('.pagination-wrapper, nav.pagination, .pagination');
        if (oldPag && newPag) {
          oldPag.parentNode.replaceChild(document.importNode(newPag, true), oldPag);
        } else if (oldPag) {
          oldPag.remove();
        } else if (newPag && grid.parentNode) {
          grid.insertAdjacentElement('afterend', document.importNode(newPag, true));
        }

        // oppdater URL uten aa navigere
        try { history.pushState({ fjChips: url }, '', url); } catch (e) {}

        // Start uendelig rulling paa nytt for den NYE kolleksjonen.
        // fjInfReinit (tb27) pensjonerer den gamle instansen via
        // generasjonstelleren og leser fersk neste-lenke fra pagineringen
        // vi nettopp byttet. Kalles ETTER pushState saa "du har sett alt"-
        // kortene bygges for riktig sti.
        if (window.fjInfReinit) window.fjInfReinit();

        // re-synk onskeliste-hjerter paa nye kort
        if (window.fjWish) window.fjWish.set(window.fjWish.get());

        // oppdater drill-down subchips (skittfiske-stil)
        if (window.fjRenderSubchips) window.fjRenderSubchips();
      })
      .catch(() => {
        window.location.href = url;
      });
  }

  function ensureDefault(root) {
    const bars = (root || document).querySelectorAll('.fj-chips-bar');
    bars.forEach((bar) => {
      const chips = bar.querySelectorAll(chipSelector);
      if (!chips.length) return;

      let active = bar.querySelector(chipSelector + '.is-active');
      if (!active) {
        active = bar.querySelector('[data-filter="all"]');
        if (active) setActive(bar, active);
      }

      if (active) {
        const filter = active.dataset.filter || 'all';
        applyFilter(bar, filter);
      }
    });
  }

  document.addEventListener('click', (e) => {
    const chip = e.target.closest(chipSelector);
    if (!chip) return;
    const bar = chip.closest('.fj-chips-bar');
    if (!bar) return;

    e.preventDefault();
    if (chip.tagName === 'BUTTON' && !chip.getAttribute('type')) {
      chip.setAttribute('type', 'button');
    }

    const filter = chip.dataset.filter || 'all';
    const collection = chip.dataset.collection;

    // Kategori-chip: bytt grid paa stedet - ALDRI full sideomlasting
    if (filter === 'category' && collection) {
      swapCollection(bar, chip, collection);
      return;
    }

    setActive(bar, chip);
    applyFilter(bar, filter);
  });

  // Kolleksjonssidens kategori-chips er <a>-lenker - fang dem og bytt grid paa stedet
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a.fj-chips__chip');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (href.indexOf('/collections/') === -1) return;
    e.preventDefault();
    const nav = a.closest('.fj-chips__nav');
    if (nav) {
      nav.querySelectorAll('.fj-chips__chip').forEach((c) => c.classList.remove('active'));
      a.classList.add('active');
    }
    swapByUrl(href.split('?')[0]);
  });

  document.addEventListener('DOMContentLoaded', () => ensureDefault(document));
  document.addEventListener('shopify:section:load', (e) => ensureDefault(e.target));
  document.addEventListener('shopify:section:select', (e) => ensureDefault(e.target));

  // Temu-style hide/show on scroll (mobile only)
  let lastScrollY = 0;
  let ticking = false;

  function handleScroll() {
    const bars = document.querySelectorAll('.fj-chips-bar');
    if (!bars.length) return;

    const scrollY = window.scrollY;
    const scrollingDown = scrollY > lastScrollY;
    const scrollThreshold = 100;

    bars.forEach((bar) => {
      if (window.innerWidth > 989) {
        bar.classList.remove('fj-chips-bar--hidden');
        return;
      }

      if (scrollY < scrollThreshold) {
        bar.classList.remove('fj-chips-bar--hidden');
      } else if (scrollingDown && scrollY > lastScrollY + 5) {
        bar.classList.add('fj-chips-bar--hidden');
      } else if (!scrollingDown && lastScrollY > scrollY + 5) {
        bar.classList.remove('fj-chips-bar--hidden');
      }
    });

    lastScrollY = scrollY;
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(handleScroll);
      ticking = true;
    }
  });

  // ===== Drill-down subchips (skittfiske-stil nivaa 2) =====
  // /collections/fiske/stenger  -> [Alle][Stenger*][Haspel][Hav][Flue][Kombo] + arter
  // /collections/fiske/stenger+haspelstang -> Haspel aktiv
  // header + drawer over chips-raden (z-fix)
  (function () {
    var st = document.createElement('style');
    st.textContent = 'body .section-header{position:sticky;z-index:1002 !important}';
    document.head.appendChild(st);
  })();

  var FJ_SUBS = {
    stenger: [['haspelstang', 'Haspel & spinning'], ['havstang', 'Havfiske'], ['fluestang', 'Flue'], ['fiskesett', 'Kombo-sett']],
    sluk: [['wobbler', 'Wobbler'], ['spinner', 'Spinner'], ['pilk', 'Pilk']],
    sene: [['monofilament', 'Monofilament'], ['multifilament', 'Multifilament']]
  };
  var FJ_TYPES = ['stenger', 'sneller', 'sluk', 'fluer', 'sene', 'kroker', 'agn', 'dupp'];
  var FJ_TYPE_TITLES = { stenger: 'Stenger', sneller: 'Sneller', sluk: 'Sluk', fluer: 'Fluer', sene: 'Sene', kroker: 'Kroker', agn: 'Agn', dupp: 'Dupp' };

  function fjUpdateCrumbs(type, sub, subs) {
    var first = document.querySelector('.fj-breadcrumbs__item');
    var list = first ? first.parentElement : document.querySelector('.fj-chips__crumbs');
    if (!list) return;
    list.querySelectorAll('.fj-crumb-x').forEach(function (e) { e.remove(); });
    if (!type) return;
    function add(html) {
      var el = document.createElement(first ? 'li' : 'span');
      el.className = (first ? 'fj-breadcrumbs__item ' : '') + 'fj-crumb-x';
      el.innerHTML = html;
      list.appendChild(el);
    }
    var existing = Array.prototype.map.call(list.children, function (e) { return e.textContent.trim().toLowerCase(); });
    var typeTitle = FJ_TYPE_TITLES[type] || type;
    if (existing.indexOf(typeTitle.toLowerCase()) === -1) {
      add('<a href="/collections/fiske/' + type + '">' + typeTitle + '</a>');
    }
    if (sub) {
      var lbl = sub;
      (subs || []).forEach(function (p) { if (p[0] === sub) lbl = p[1]; });
      if (existing.indexOf(lbl.toLowerCase()) === -1) add('<span>' + lbl + '</span>');
    }
  }

  window.fjRenderSubchips = function () {
    var navs = Array.prototype.slice.call(document.querySelectorAll('.fj-chips__nav'));
    var nav = navs.filter(function (n) { return n.offsetParent; })[0] || navs[0];
    if (!nav) return;

    // nullstill: fjern injiserte subs, vis alle chips igjen
    nav.querySelectorAll('.fj-chips__chip--sub').forEach(function (c) { c.remove(); });
    nav.querySelectorAll('a.fj-chips__chip').forEach(function (a) { a.style.display = ''; });

    var m = location.pathname.match(/^\/collections\/fiske\/([a-z0-9-]+)(?:\+([a-z0-9-]+))?$/);
    if (!m) { fjUpdateCrumbs(null); return; }
    var type = m[1], sub = m[2] || null;
    var subs = FJ_SUBS[type];
    fjUpdateCrumbs(FJ_TYPE_TITLES[type] ? type : null, sub, subs);
    if (!subs) return;

    // rot-'Alle' skal ikke staa aktiv i drill-down
    nav.querySelectorAll('a.fj-chips__chip').forEach(function (a) {
      var h = (a.getAttribute('href') || '').replace(/\/$/, '');
      if (h.slice(-19) === '/collections/fiske') a.classList.remove('active');
    });

    // skjul soesken-typer (skittfiske viser kun barna naar man er inne i en kategori)
    nav.querySelectorAll('a.fj-chips__chip').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      var mm = href.match(/\/collections\/fiske\/([a-z]+)$/);
      if (mm && FJ_TYPES.indexOf(mm[1]) > -1 && mm[1] !== type) a.style.display = 'none';
    });

    var typeChip = Array.prototype.slice.call(nav.querySelectorAll('a.fj-chips__chip')).filter(function (a) {
      return (a.getAttribute('href') || '').replace(/\/$/, '').slice(-('/collections/fiske/' + type).length) === '/collections/fiske/' + type;
    })[0];
    if (!typeChip) return;

    typeChip.classList.toggle('active', !sub);
    var after = typeChip;
    subs.forEach(function (pair) {
      var a = document.createElement('a');
      a.className = 'fj-chips__chip fj-chips__chip--sub' + (sub === pair[0] ? ' active' : '');
      a.href = '/collections/fiske/' + type + '+' + pair[0];
      a.textContent = pair[1];
      after.insertAdjacentElement('afterend', a);
      after = a;
    });
  };

  document.addEventListener('DOMContentLoaded', function () { window.fjRenderSubchips(); });
  window.addEventListener('popstate', function () { window.fjRenderSubchips(); });

})();
